<!--  -->
<template>
  <div class="box">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>计量服务方案</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="content">
        <div class="content-box">
            <div class="top">
                <div class="left">
                    <img src="../../assets/img/jiliangnengli/icon.png" alt="">
                    <div class="text">
                        <div class="title">服务方案</div>
                        <div class="en-text">service scheme</div>
                    </div>
                </div>
                <div class="right">为您找到符合要求的服务方案 <span style="color: #1677ff;">{{ jiliangServerTotal }}</span> 个</div>
            </div>
            <div class="list">
                <div class="item" v-for="(item, index) in zizhiServerList" :key="index" @click="clickItemFun(item)">
                    <img class="img" :src="downloadUrl + item.photo" alt="">
                    <div class="info">
                      <div class="unit">{{ item.title }}</div>
                      <div class="name" style="margin-top: 10px;">
                          <img src="../../assets/img/jiliangnengli/unit-icon.png" class="unit-icon" alt="">
                          <div>{{ item.provider }}</div>
                      </div>
                        <!-- <div class="unit"></div> -->
                    </div>
                </div>
            </div>
            <div class="bottom">
                <el-pagination
                    layout="prev, pager, next"
                    :total="jiliangServerTotal"
                    @current-change="currentPage"
                    @prev-click="shang"
                    @next-click="xia"
                    :page-size="pageSize"
                >
                </el-pagination>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { Server,httpurl } from "@/server";
export default {
    data () {
        return {
            
            pageSize: 8,
            pageNo: 1,
            zizhiServerList: 0, // 资质证书总条数
            jiliangServerTotal: 0, // 产业计量中心总条数
            downloadUrl: '',
        }
    },
    created() {
        this.getData()
        this.downloadUrl = this.$downloadUrl
    },

    methods: {
        getData() {
            Server.getJiliangServerList({pageNo: this.pageNo,pageSize:this.pageSize}).then(res => {
                console.log(res);
                if(res.success) {
                    this.zizhiServerList = res.result.records
                    this.jiliangServerTotal = res.result.total
                }
            })
        },
        clickItemFun(item) {
          this.$router.push({
                path: 'jiliangServiceDetail',
                query: {
                  id: item.id
                },
            })
        },
        currentPage(page) {
            this.pageNo = page;
            this.getData()
        },
        xia() {
            this.pageNo = this.pageNo + 1;
            this.getData()
        },
        shang() {
            this.pageNo = this.pageNo - 1;
            this.getData()
        },
    }
}
</script>

<style lang="less" scoped>
    .content {
        width: 1100px;
        margin-top: 15px;
        .content-box {
            background-color: #fff;
            padding: 10px;
            box-sizing: border-box;
            margin-bottom: 20px;

            display: block;
            .top {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 15px 0;
                border-bottom: 1px solid #ccc;
                .left {
                    display: flex;
                    img {
                        width: 40px;
                        height: 35px;
                        margin: 0 15px;
                    }
                    .text {
                        color: #1677ff;
                        .title {
                            font-size: 24px;
                            font-weight: bold;
                        }
                        .en-text {
                            font-size: 14px;
                        }
                    }
                }
                .right {
                    color: #999;
                }
            }

            .list {
                margin: 30px 10px;
                display: flex;
                flex-wrap: wrap;
                .item {
                    width: 22%;
                    padding: 10px;
                    box-sizing: border-box;
                    border: 1px solid #ccc;
                    margin: 20px;
                    &:nth-child(4n) {
                        margin-right: 3px;
                    }
                    &:nth-child(4n+1) {
                        margin-left: 4px;
                    }
                    .img {
                        width: 100%;
                        height: 160px;
                        padding-bottom: 20px;
                        border-bottom: 1px solid #ccc;
                    }
                    .info {
                        margin: 20px 0;
                        font-size: 14px;
                        .name {
                            display: flex;
                            .unit-icon {
                                width: 17px;
                                height: 20px;
                                margin-right: 10px;
                            }
                        }
                    }
                    &:hover {
                        box-shadow: 0 0 15px #ccc;
                    }
                }
            }
            .bottom {
                display: flex;
                justify-content: center;
                margin-bottom: 10px;
            }
            &:hover {
                box-shadow: 0 0 15px #ccc;
            }
        }
    }
</style>
